import type {
  IPayRequestDto,
  IPayResponse,
  ICheckoutDTO,
  ICheckoutResponse,
  ICheckoutDtoData,
  ICreateOrderDto,
  ICreateOrderResponse,
} from './models';
import type { Options } from 'ky';

import { MMGatewayClient } from '../MMGatewayClient';

class _CheckoutClient extends MMGatewayClient {
  public async payOrder(orderNumber: string, data: IPayRequestDto) {
    return this.post<IPayResponse, IPayRequestDto>(`market/v1/orders/${orderNumber}/pay`, data);
  }

  public async getCheckoutInfo({ data, cartId, addressId }: ICheckoutDTO) {
    const options: Options = {
      headers: {
        'x-delivery-type': data.delivery.type,
        'x-address-id': addressId,
      },
    };

    return this.post<ICheckoutResponse, ICheckoutDtoData>(`v1/checkout/${cartId}`, data, options);
  }

  public async createOrder({ data, cartId, addressId }: ICreateOrderDto) {
    const options: Options = {
      headers: {
        'x-delivery-type': data.delivery.type,
        'x-address-id': addressId,
      },
    };

    return this.post<ICreateOrderResponse, ICreateOrderDto['data']>(
      `v1/checkout/${cartId}/order`,
      data,
      options
    );
  }
}

export const CheckoutClient = new _CheckoutClient();
